import { render, staticRenderFns } from "./FileMappings.vue?vue&type=template&id=31c76298&scoped=true&"
import script from "./FileMappings.vue?vue&type=script&lang=js&"
export * from "./FileMappings.vue?vue&type=script&lang=js&"
import style0 from "./FileMappings.vue?vue&type=style&index=0&id=31c76298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c76298",
  null
  
)

export default component.exports
import {QPage,QBreadcrumbs,QBreadcrumbsEl,QToggle,QCard,QCardSection,QScrollArea,QList,QItem,QItemSection,QItemLabel,QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBreadcrumbs,QBreadcrumbsEl,QToggle,QCard,QCardSection,QScrollArea,QList,QItem,QItemSection,QItemLabel,QBtn,QTooltip})
